import { render, staticRenderFns } from "./datapersent.vue?vue&type=template&id=948cd2c0&scoped=true"
import script from "./datapersent.vue?vue&type=script&lang=js"
export * from "./datapersent.vue?vue&type=script&lang=js"
import style0 from "./datapersent.vue?vue&type=style&index=0&id=948cd2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948cd2c0",
  null
  
)

export default component.exports